import React from 'react';

//step1. 引入操作指引组件
import KinerGuide from './KinerGuide';
import './KinerGuide.css'
import KeeVue from '../components/base/KeeVue.js'

class KinerGuideView extends    KeeVue  {

    //step2. 定义操作指引信息对象
    guideList = [];
	 
	

    constructor(props) {
        super(props);
        //step3. 初始化操作变量
        const {  guideStep } = props;
 //        this.guideList = [
	//   {position: 'bottom', title:'新建表单', text: "点击新建表单按钮打开表单编辑工具，开始创建属于您表单。", offset: 15},
	//   {position: 'bottom', title:'表单标题及描述', text: "请为表单起一个标题，并添加描述。表单标题和描述将会出现在表单填报页面。", offset: 15},
	//   {position: 'bottom', title:'添加组件', text: "点击或向左侧拖拽组件添加表单字段，并可以通过拖拽来改变组件顺序。", offset: -15},
	//   {position: 'bottom', title:'保存表单', text: "点击保存按钮创建表单，下次可继续进行编辑操作。", offsetX: -15},
	//   {position: 'top', title:'开启收集', text: "表单创建之后需要开启收集才可以分享至用户进行填报。", offset: -15},
	//   {position: 'bottom', title:'发放表单', text: "将二位码发放至用户侧，用户可以通过手机扫码填报。", offsetX: -15},
	//   {position: 'bottom', title:'查看详情', text: "点击详情，可以查看表单的填报结果。", offsetX: -15}
	// ];
	 this.guideList =[];
        this.state = {
            disabled: false,//忽略，与本组件无关
            isShowGuide: false,//是否显示操作指引，通过控制此开关便可显示和隐藏操作指引
            guideStep: guideStep || 0//当前操作指引的步骤
        };
    }

    componentDidMount() {
		 
        //step4. 在页面准备完毕时显示操作指引
       
	  
	   {
		   this.onEvent("showHelpGuide",(helpInfos,from)=>{
			   
			   if(	window.closeGuideInfo )
			   {
				   return ;
			   }
			   
			 // if(!localStorage.getItem(window.currentUserId+"guideInfoHide"+from))
			 // {
				 
				 
				//  this.guideList = helpInfos;
				//  this.setState({
				// 	 from:from,
				//      isShowGuide: true//当页面加载成功或者是如果操作指引依赖于某些异步操作，如axios请求等，则可在请求成功之后让操作指引显示
				//  });
			 // }
			   
			 this.doRequest("/userGuideInfo/get?id="+window.currentUserId+from,(ret)=>{
				 
				 if(ret&&ret[window.currentUserId+from])
				 {
					 
				 }
				 else
				 {
					 this.guideList = helpInfos;
					 this.setState({
					 	from:from,
					    isShowGuide: true//当页面加载成功或者是如果操作指引依赖于某些异步操作，如axios请求等，则可在请求成功之后让操作指引显示
					 });
				 }
				 
			 })
		  
		   })
	   }
		 
		
    }
	
	


    render() {

		if(this.state.isShowGuide&&this.guideList&&this.guideList.length>0)
		{
			return (
			    //step5. 为页面根元素增加ref,以便操作指引组件获取该对象进行操作
			    <div className='guideModalcontainer' ref='guideBox'>
			        {/*step6. 为需要添加操作指引的元素添加ref,以便操作指引插件获取该对象进行操作，如果有多个步骤，一个页面可以添加多个，如guideTarget0,guideTarget1,guideTarget2等*/}
			        
			
			
			        {/*step7. 页面中使用KinerGuide组件，传入相关配置进行配置组件*/}
			
			        {/*visible：         是否显示显示操作指引*/}
			        {/*guideBox：        页面容器对象，即step5中指定的元素*/}
			        {/*target：          操作指引目标元素，即step6中指定的元素*/}
			        {/*type：            操作指引弹框的类型，可选择 方形：square，圆形：circular*/}
			        {/*offset：          操作指引框偏移量，优先级高于offsetX和offsetY*/}
			        {/*offsetX：         水平偏移量*/}
			        {/*offsetY：         垂直偏移量*/}
			        {/*guidePosition：   操作提示面板的位置，可选择：自动：auto 操作指引框上方：top 操作指引框下方：bottom*/}
			       {  <KinerGuide
			            visible={this.state.isShowGuide}
			            guideBox={this.refs.guideBox}
						guideList={this.guideList}
						from={this.state.from}
			            target={this.guideList[this.state.guideStep].target}
			            type={this.guideList[this.state.guideStep].type}
			            offset={this.guideList[this.state.guideStep].offset}
			            offsetX={this.guideList[this.state.guideStep].offsetX}
			            offsetY={this.guideList[this.state.guideStep].offsetY}
			            guidePosition={this.guideList[this.state.guideStep].position}
						onClose={()=>{this.state.isShowGuide=false;this.refresh();}}
			        >
			            {/*操作指引提示框框，可在此处自定义添加代码实现业务逻辑*/}
			            
			        </KinerGuide>
					
					}
			    </div>
			);
		}
		else
		{
			return <div></div>
		}
        
    }
}

export default KinerGuideView;